import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { addQuizFailure, addQuizStart, addQuizSuccess } from '../../../redux/quizRedux';
import { validateRequired } from '../../../formValidation';
import { userRequest } from '../../../requestMethod';

const NewQuiz = () => {

    const [courseId, setCourseId] = useState('');
    const [title, setTitle] = useState('');
    const [questions, setQuestions] = useState([{ question: '', options: ['', '', '', ''], correctAnswer: 0, explanation: '', marks: 1 }]);
    const [minPassingMarks, setMinPassingMarks] = useState(1);
    const [totalMarks, setTotalMarks] = useState(0);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const calculateTotalMarks = (questions) => {
        return questions.reduce((total, question) => total + Number(question.marks), 0);
    };


    const handleQuestionChange = (index, field, value) => {
        const updatedQuestions = [...questions];
        updatedQuestions[index][field] = value;
        // const calculatedTotalMarks = calculateTotalMarks(updatedQuestions);
        // setTotalMarks(calculatedTotalMarks);
        setQuestions(updatedQuestions);
    };

    useEffect(() => {
        const calculatedTotalMarks = calculateTotalMarks(questions);
        setTotalMarks(calculatedTotalMarks);
    }, [questions]);


    const handleOptionChange = (questionIndex, optionIndex, value) => {
        const updatedQuestions = [...questions];
        updatedQuestions[questionIndex].options[optionIndex] = value;
        setQuestions(updatedQuestions);
    };

    const handleCorrectAnswerChange = (questionIndex, value) => {
        const updatedQuestions = [...questions];
        updatedQuestions[questionIndex].correctAnswer = value;
        setQuestions(updatedQuestions);
    };

    const handleAddQuestion = () => {
        const newQuestion = { question: '', options: ['', '', '',''], correctAnswer: 0, explanation: '', marks: 1 };
        setQuestions([...questions, newQuestion]);
    };

    const handleRemoveQuestion = (index) => {
        const updatedQuestions = [...questions];
        updatedQuestions.splice(index, 1);
        setQuestions(updatedQuestions);
    };

    const handleExplanationChange = (questionIndex, value) => {
        const updatedQuestions = [...questions];
        updatedQuestions[questionIndex].explanation = value;
        setQuestions(updatedQuestions);
    };

    const handleMarksChange = (questionIndex, value) => {
        const updatedQuestions = [...questions];
        updatedQuestions[questionIndex].marks = value;
        setQuestions(updatedQuestions);
    };




    const dispatch = useDispatch();

    const addQuiz = async (dispatch, quiz) => {
        dispatch(addQuizStart());
        try {
            const res = await userRequest.post('quiz/create', quiz);
            dispatch(addQuizSuccess(res.data));
            if (res.status === 200) {
                setSuccess(true);
                setSuccessMessage("Quiz has been added!");
                // setFirstName('');
                // setLastName('');
                // setEmail('');
                // setPhone('');
                // setDateOfBirth('');
            }
        } catch (error) {
            dispatch(addQuizFailure());
            if (error.response.status === 409) {
                setEmailError(true);
                setEmailErrorMessage(error.response.data);
            }

            else {
                setError(true);
                setErrorMessage("Something went wrong!");
            }
        }
    };

    // Validate function for form validation start=======
    const [errors, setErrors] = useState({});
    const validateForm = () => {
        let formIsValid = true;
        const newErrors = {};

        const titleValidErr = validateRequired(title);
        const minPassingMarksValidErr = validateRequired(minPassingMarks);
        // const emailValidErr = validateRequired(email);
        // const phoneValidErr = validateRequired(phone);
        // const dobValidErr = validateRequired(dateOfBirth);

        if (titleValidErr) {
            formIsValid = false;
            newErrors.title = titleValidErr;
        }
        if (minPassingMarksValidErr) {
            formIsValid = false;
            newErrors.minPassingMarks = minPassingMarksValidErr;
        }

        if (minPassingMarks >= totalMarks) {
            formIsValid = false;
            newErrors.minPassingMarks = "Minimum passing marks should be less than total marks";
        }

        // if (emailValidErr) {
        //     formIsValid = false;
        //     newErrors.email = emailValidErr;
        // }
        // if (phoneValidErr) {
        //     formIsValid = false;
        //     newErrors.phone = phoneValidErr;
        // }
        // if (dobValidErr) {
        //     formIsValid = false;
        //     newErrors.dob = dobValidErr;
        // }

        setErrors(newErrors);
        return formIsValid;
    }
    // Validate function for form validation end==========z

    const handleStudentData = () => {
        setEmailError(false);
        setSuccess(false);

        if (validateForm() && minPassingMarks < totalMarks) {
            addQuiz(dispatch, { title, questions, minPassingMarks, totalMarks });
        }
    }


    return (
        <>
            <div className="NewRegisterFormWrapper">
                <div className="container">
                    <div className="row">
                        <h1 className="page-heading py-4">Add New Quiz</h1>
                        <div className="col-10">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-input-wrapper">
                                        <label>Title</label>
                                        <input type="text" className='newUserInput' placeholder='Quiz Title' value={title} onChange={(e) => setTitle(e.target.value)} />
                                        <span className='error-text'>{errors.title}</span>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-input-wrapper">
                                        {questions.map((question, index) => (
                                            <div className="col-12" key={index}>
                                                <div className="form-input-wrapper">
                                                    <label>Question {index + 1}:</label>
                                                    <input type="text" placeholder='Type your question here...' className='newUserInput' value={question.question} onChange={(e) => handleQuestionChange(index, 'question', e.target.value)} />
                                                </div>
                                                <div className="form-input-wrapper">
                                                    <label>Options:</label>
                                                    {question.options.map((option, optionIndex) => (
                                                        <input
                                                            key={optionIndex}
                                                            className='newUserInput'
                                                            type="text"
                                                            value={option}
                                                            placeholder={`Option ${optionIndex + 1}`}
                                                            onChange={(e) => handleOptionChange(index, optionIndex, e.target.value)}
                                                        />
                                                    ))}
                                                </div>
                                                <div className="form-input-wrapper">
                                                    <label>Correct Answer:</label>
                                                    <select className='newUserInput' value={question.correctAnswer} onChange={(e) => handleCorrectAnswerChange(index, e.target.value)}>
                                                        {question.options.map((option, optionIndex) => (
                                                            <option key={optionIndex} value={optionIndex}>
                                                                {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-input-wrapper">
                                                    <label>Explanation:</label>
                                                    <textarea
                                                        type="text"
                                                        className="newUserInput"
                                                        value={question.explanation}
                                                        onChange={(e) => handleExplanationChange(index, e.target.value)}

                                                    />
                                                </div>
                                                <div className="form-input-wrapper">
                                                    <label>Marks:</label>
                                                    <input
                                                        type="text"
                                                        className="newUserInput"
                                                        value={question.marks}
                                                        onChange={(e) => handleMarksChange(index, e.target.value)}
                                                    />
                                                </div>

                                                {questions.length > 1 && (
                                                    <button className='custom-btn' onClick={() => handleRemoveQuestion(index)}>Remove Question</button>
                                                )}
                                            </div>
                                        ))}
                                        <button className='custom-btn' onClick={handleAddQuestion}>Add Question</button>
                                        <div className="col-12">
                                            <div className="form-input-wrapper">
                                                <label>Minimum Passing Marks:</label>
                                                <input
                                                    type="text"
                                                    className="newUserInput"
                                                    value={minPassingMarks}
                                                    onChange={(e) => setMinPassingMarks(e.target.value)}
                                                />
                                                <span className='error-text'>{errors.minPassingMarks}</span>
                                            </div>
                                        </div>
                                        <div className="form-input-wrapper">
                                            <label>Total Marks:</label>
                                            <input
                                                type="text"
                                                className="newUserInput"
                                                value={totalMarks}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="newStudentSubmitbtn">
                                        <button className="custom-btn purple-bg" onClick={handleStudentData}>create</button>
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    {
                                        success ? (
                                            <div className='alert alert-success'>
                                                {successMessage}
                                            </div>
                                        ) : error && (
                                            <div className='alert alert-danger'>
                                                {errorMessage}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewQuiz
